import { ITask } from '@src/terminal/core/services/gravity/_private/Task';
import store from '@app/store';

class TicketsRebetTask implements ITask {
    execute = (message?: any): void => {
        const { id } = message.data.ticket.slip.codes[0];
        console.log('SSBT::Tickets checked slip code id', id);
        store.dispatch(
            'data/country/setCheckedTicket',
            { id, timeChecked: Date.now() },
            { root: true },
        );
    };
}

export default TicketsRebetTask;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--12!./src/terminal/core/services/gravity/_private/TicketsCheckedTask.ts